// extracted by mini-css-extract-plugin
export default {"rating":"dL-z","numberOfStars":"eL-z","count":"fL-z","barGraphSpacing":"gL-z","barGraph":"hL-z"};